import { render, staticRenderFns } from "./Charpter_one.vue?vue&type=template&id=71448167&"
import script from "./Charpter_one.vue?vue&type=script&lang=js&"
export * from "./Charpter_one.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports